import React, { useEffect, useState } from 'react';

import CTable from '../../../components/table/table';
import {
  addAccount,
  getAllSecondaryAccounts,
  getPrincipalAccounts,
  updateAccount,
  updateAccountAsAdmin
} from '../../../network/user';
import { notify } from '../../../notifications/notification';
import CButton from '../../../components/button/button';
import {
  IAccount,
  ISecondaryAccount
} from '../../../utils/interfaces/interfaces';
import { sort_alphabetically } from '../../../utils/lists';
import CModal from '../../../components/modal/modal';
import AddAccount from '../../../components/forms/add_accounts';
import styles from './../../accounts/accounts.module.scss';
import { users_status } from '../../../types/users';
import { getInstitution } from '../../../network/institution';
import {
  columns_principal_accounts,
  columns_secondary_admin
} from '../../../utils/tables';
import { Skeleton } from 'antd';

const AccountsAdmin = () => {
  const [loading, setLoading] = useState(false);
  const [data, setList] = useState([]);
  const [secondaryAccounts, setAccounts] = useState([]);
  const [openedModal, setModal] = useState(false);
  const [openedModalSecondary, setSecondaryModal] = useState(false);
  const [currentAccount, setCurrentAccount] = useState({} as IAccount);

  const updateList = () => {
    getPrincipalAccounts(async data => {
      const full_data = await Promise.all(
        data.map(async (elem: IAccount) => {
          let completed = { ...elem, institutionName: '' };
          if (elem.institutionId) {
            await getInstitution(elem.institutionId).then(({ data }) => {
              completed = { ...completed, institutionName: data.name };
            });
          }
          return completed;
        })
      );

      setList(sort_alphabetically(full_data, 'email'));
    });
  };

  const updateListSecondary = () => {
    getAllSecondaryAccounts().then(async ({ data }) => {
      const full_data = await Promise.all(
        data.data.map(async (elem: ISecondaryAccount) => {
          let completed = { ...elem, institutionName: '' };
          if (elem.institutionId) {
            await getInstitution(elem.institutionId).then(({ data }) => {
              completed = { ...completed, institutionName: data.name };
            });
          }
          return completed;
        })
      );
      setLoading(false);
      setAccounts(sort_alphabetically(full_data, 'email'));
    });
  };

  useEffect(() => {
    setLoading(true);
    updateList();
    updateListSecondary();
  }, []);

  const increaseNumber = (account: IAccount) => {
    updateAccountAsAdmin({
      ...account,
      secondaryAccountAllowance: account.secondaryAccountAllowance + 1
    }).then(() => updateList());
  };

  const decreaseNumber = (account: IAccount) => {
    if (account.secondaryAccountAllowance > 0) {
      updateAccountAsAdmin({
        ...account,
        secondaryAccountAllowance: account.secondaryAccountAllowance - 1
      }).then(() => updateList());
    } else {
      notify(
        'Acest utilizator are deja 0 conturi pe care le poate administra.',
        'warning'
      );
    }
  };

  const enable = (account: IAccount) => {
    updateAccountAsAdmin({
      ...account,
      status: users_status.active
    }).then(() => {
      updateList();
      notify('Ati activat cu succes acest cont.', 'success');
    });
  };

  const disable = (account: IAccount) => {
    updateAccountAsAdmin({
      ...account,
      status: users_status.disabled
    }).then(() => {
      updateList();
      notify('Ati dezactivat cu succes acest cont.', 'success');
    });
  };

  const addNewAccount = () => {
    setModal(!openedModal);
  };

  const openEdit = (entry: IAccount) => {
    setCurrentAccount(entry);
    setModal(true);
  };

  const openEditSecondary = (entry: IAccount) => {
    setCurrentAccount(entry);
    setSecondaryModal(true);
  };

  const handleModal = (event: boolean) => {
    setModal(event);
    setCurrentAccount({} as IAccount);
  };

  const handleModalSecondary = (event: boolean) => {
    setSecondaryModal(event);
    setCurrentAccount({} as IAccount);
  };

  return (
    <div className={styles.containerAccounts}>
      <CModal opened={openedModal} openModal={handleModal}>
        <AddAccount
          isAdmin
          selectedAccount={currentAccount}
          callback={() => {
            updateList();
            setModal(false);
            setCurrentAccount({} as IAccount);
          }}
          addAccount={addAccount}
        />
      </CModal>

      <CModal opened={openedModalSecondary} openModal={handleModalSecondary}>
        <AddAccount
          selectedAccount={currentAccount}
          callback={() => {
            updateListSecondary();
            setSecondaryModal(false);
            setCurrentAccount({} as IAccount);
          }}
          addAccount={addAccount}
        />
      </CModal>
      <div className={styles.rowInfo}>
        <div className={styles.text}>
          <p className='subheading-dark bold'>Gestionare conturi principale</p>
        </div>
        <CButton
          type='button'
          label='Adaugă cont nou'
          onClick={addNewAccount}
        />
      </div>

      {loading && <Skeleton active />}
      {!loading && (
        <CTable
          data={data && data.map((el: IAccount) => ({ ...el, key: el.id }))}
          columns={columns_principal_accounts(
            openEdit,
            enable,
            disable,
            decreaseNumber,
            increaseNumber,
            styles
          )}
        />
      )}

      {!loading && (
        <div className={styles.rowInfo}>
          <div className={styles.text}>
            <p className='subheading-dark bold'>
              Vizualizare conturi secundare
            </p>
          </div>
        </div>
      )}
      {!loading && (
        <CTable
          data={
            secondaryAccounts &&
            secondaryAccounts.map((el: IAccount) => ({ ...el, key: el.id }))
          }
          columns={columns_secondary_admin(styles, openEditSecondary)}
        />
      )}
    </div>
  );
};

export default AccountsAdmin;
